// The only external host KIM may link to or load images from (help-centre citations). This
// whitelist is the real enforcement boundary — KIM's system prompt is only a soft control, so a
// hallucinated or injected URL must be neutralised here in the renderer.
//
// Kept in its own dependency-free module so it is unit-testable without pulling in the whole
// component graph.
export const HELP_HOST = 'help.klayo.com';

// Fail-closed host check: parse the URL and require https + an EXACT host match. Using URL()
// (not string matching) defeats userinfo (@evil.com), subdomain-suffix (help.klayo.com.evil.com),
// trailing-dot, port, and javascript:/data: tricks; anything unparseable is rejected.
export function isWhitelistedHelpUrl(url?: string): boolean {
  if (!url) return false;
  try {
    const u = new URL(url, window.location.origin);
    return u.protocol === 'https:' && u.hostname === HELP_HOST;
  } catch {
    return false;
  }
}
